var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntakePartComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 200,
    viewBox: "0 0 202 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_well_done_re_3hpo (1) 1",
    clipPath: "url(#clip0_254_14388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M201.749 199.542C201.749 199.796 201.546 200 201.292 200H0.707993C0.454533 200 0.250977 199.796 0.250977 199.542C0.250977 199.289 0.454533 199.085 0.707993 199.085H201.292C201.546 199.085 201.749 199.289 201.749 199.542Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M139.484 177.267L141.788 186.879L134.876 188.801L133.339 178.42L139.484 177.267Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M150.622 146.124L143.325 152.275L138.716 159.58L145.245 163.809L156.382 151.122L150.622 146.124Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M148.317 82.6851L154.462 103.447C154.462 103.447 181.729 127.284 179.041 132.283C176.353 137.281 158.302 151.122 158.302 151.122C158.302 151.122 159.642 155.548 155.708 153.719C151.774 151.891 147.549 146.893 147.549 146.893C147.549 146.893 147.549 143.048 149.469 143.817C151.39 144.586 160.223 134.205 160.223 134.205L141.02 116.519V175.657C141.02 175.657 145.629 179.691 141.02 180.017C136.412 180.342 132.187 181.111 132.187 181.111C132.187 181.111 126.811 179.189 128.731 177.266L122.97 145.739L118.746 107.292L121.818 87.2988L148.317 82.6851Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M136.028 185.725C136.028 185.725 136.412 184.187 137.948 184.187H142.64C142.64 184.187 144.093 190.723 143.709 190.723C143.325 190.723 149.853 199.182 142.941 199.566C136.028 199.951 134.107 199.182 134.107 199.182L133.339 196.147C133.339 196.147 132.187 194.183 132.571 192.645C132.955 191.108 136.028 185.725 136.028 185.725Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M145.629 160.734C145.629 160.734 150.04 160.664 148.987 161.852C147.933 163.041 146.013 164.963 146.013 164.963C146.013 164.963 141.445 174.19 139.313 172.46C137.18 170.73 133.724 151.506 134.876 149.199C136.028 146.893 137.564 146.893 137.564 146.893L144.649 151.159C144.649 151.159 140.252 161.887 145.629 160.734Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M134.876 50.0047L136.412 40.3928L126.043 36.1636L124.506 50.7737L134.876 50.0047Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.1,
    d: "M134.876 50.0047L136.412 40.3928L126.043 36.1636L124.506 50.7737L134.876 50.0047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M123.93 48.6588L136.22 45.583L149.277 49.8123C149.277 49.8123 155.038 65.9603 153.118 71.7274C151.198 77.4946 151.198 88.7594 151.198 88.7594C151.198 88.7594 151.006 83.8384 139.868 87.2987C128.731 90.759 120.666 90.3745 120.666 90.3745L120.282 76.5334L115.457 64.239C113.395 58.9841 115.618 53.0178 120.614 50.3981L123.93 48.6588Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-1b03a630-7e31-41b5-b302-96493ff31189-397",
    d: "M180.345 93.9513C182.079 96.0312 182.413 98.6128 181.09 99.7174C179.768 100.822 177.291 100.031 175.556 97.9505C174.852 97.1288 174.355 96.1502 174.106 95.0966L166.869 86.1913L170.394 83.3354L177.799 92.0113C178.79 92.4451 179.663 93.1104 180.345 93.9513Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M148.72 49.9351L146.201 59.9223L158.528 79.6763L171.111 92.3375L175.19 88.95L162.499 73.1416L152.879 52.773L148.72 49.9351Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M178.064 40.2953C186.842 39.6458 193.293 30.1068 192.473 18.9892C191.652 7.87165 183.87 -0.614436 175.092 0.0350105C166.314 0.684457 159.863 10.2235 160.683 21.3411C161.504 32.4586 169.286 40.9447 178.064 40.2953Z",
    fill: "#B8D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M177.73 40.2949H176.962V116.974H177.73V40.2949Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M177.921 38.6758L178.013 41.3929L179.24 43.9082L174.123 43.6469L176.274 41.4809L176.031 39.0121L177.921 38.6758Z",
    fill: "#6C63FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M132.255 43.4826C138.095 43.4826 142.83 38.743 142.83 32.8966C142.83 27.0501 138.095 22.3105 132.255 22.3105C126.415 22.3105 121.681 27.0501 121.681 32.8966C121.681 38.743 126.415 43.4826 132.255 43.4826Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M131.411 18.6644C131.717 18.8432 132.127 18.5727 132.225 18.2319C132.323 17.8911 132.209 17.5292 132.096 17.1932L131.525 15.5014C131.121 14.3016 130.691 13.0599 129.815 12.1467C128.492 10.7683 126.39 10.4177 124.498 10.6717C122.068 10.9979 119.67 12.3153 118.54 14.4936C117.41 16.672 117.891 19.7116 119.933 21.0707C117.023 24.4095 116.009 28.1306 116.169 32.5587C116.329 36.9868 121.149 41.0622 124.293 44.1816C124.995 43.7556 125.633 41.7592 125.247 41.0339C124.861 40.3086 125.414 39.4684 124.936 38.8003C124.458 38.1323 124.058 39.196 124.541 38.5318C124.846 38.1126 123.656 37.1483 124.109 36.8974C126.302 35.684 127.031 32.9478 128.408 30.8525C130.069 28.3251 132.913 26.6135 135.921 26.3296C137.579 26.1732 139.329 26.4565 140.688 27.4198C142.046 28.383 142.926 30.1044 142.611 31.7409C143.426 30.9116 143.833 29.6962 143.679 28.5423C143.526 27.3885 142.817 26.3215 141.813 25.7343C142.424 23.7135 141.901 21.3889 140.484 19.8251C139.067 18.2612 133.32 18.5276 131.251 18.9392",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M131.09 26.3911C128.351 26.6872 126.373 29.0629 124.702 31.2569C123.74 32.5214 122.731 33.9179 122.755 35.5077C122.78 37.115 123.853 38.4937 124.366 40.0169C125.205 42.5067 124.387 45.469 122.391 47.175C124.364 47.5497 126.496 46.0691 126.836 44.0884C127.233 41.7826 125.487 39.5572 125.694 37.2267C125.876 35.1734 127.492 33.5932 128.866 32.0581C130.24 30.5229 131.531 28.4857 130.898 26.524",
    fill: "#2F2E41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M121.006 90.1821H42.0191C33.062 90.1821 25.8008 97.4514 25.8008 106.419V183.096C25.8008 192.063 33.0619 199.332 42.019 199.332H121.006C129.963 199.332 137.224 192.063 137.224 183.096V106.419C137.224 97.4514 129.963 90.1821 121.006 90.1821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M121.006 199.717H42.0191C32.8646 199.717 25.4167 192.261 25.4167 183.096V106.419C25.4167 97.254 32.8646 89.7979 42.0191 89.7979H121.006C130.16 89.7979 137.608 97.254 137.608 106.419V183.096C137.608 192.261 130.16 199.717 121.006 199.717ZM42.0191 90.5668C33.288 90.5668 26.1848 97.6779 26.1848 106.419V183.096C26.1848 191.837 33.288 198.948 42.0191 198.948H121.006C129.737 198.948 136.84 191.837 136.84 183.096V106.419C136.84 97.6779 129.737 90.5668 121.006 90.5668H42.0191Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M112.671 97.7253C113.683 97.7253 114.503 96.9043 114.503 95.8917C114.503 94.879 113.683 94.0581 112.671 94.0581C111.66 94.0581 110.84 94.879 110.84 95.8917C110.84 96.9043 111.66 97.7253 112.671 97.7253Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M117.708 97.7253C118.72 97.7253 119.54 96.9043 119.54 95.8917C119.54 94.879 118.72 94.0581 117.708 94.0581C116.696 94.0581 115.876 94.879 115.876 95.8917C115.876 96.9043 116.696 97.7253 117.708 97.7253Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M122.745 97.7253C123.756 97.7253 124.576 96.9043 124.576 95.8917C124.576 94.879 123.756 94.0581 122.745 94.0581C121.733 94.0581 120.913 94.879 120.913 95.8917C120.913 96.9043 121.733 97.7253 122.745 97.7253Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M39.4296 172.488C38.8606 172.488 38.3977 172.952 38.3977 173.521C38.3977 173.799 38.5049 174.056 38.6993 174.246C38.8955 174.447 39.1525 174.554 39.4296 174.554H122.038C122.607 174.554 123.069 174.091 123.069 173.521C123.069 173.244 122.962 172.987 122.768 172.797C122.572 172.596 122.315 172.488 122.038 172.488H39.4296Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M83.6007 172.144V174.898H39.4298C39.0515 174.898 38.7075 174.747 38.4599 174.492C38.2053 174.244 38.054 173.9 38.054 173.521C38.054 172.763 38.6731 172.144 39.4298 172.144L83.6007 172.144Z",
    fill: "#B8D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M120.318 166.978H106.559C105.042 166.978 103.807 165.743 103.807 164.224C103.807 162.704 105.042 161.469 106.559 161.469H120.318C121.835 161.469 123.07 162.704 123.07 164.224C123.07 165.743 121.835 166.978 120.318 166.978Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M68.6284 168.948L59.0104 136.595L58.2742 136.814L67.8585 169.053",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M68.9613 95.3182C77.7396 94.6688 84.1906 85.1297 83.3699 74.0122C82.5493 62.8946 74.7677 54.4085 65.9893 55.058C57.211 55.7074 50.76 65.2465 51.5807 76.364C52.4014 87.4816 60.1829 95.9677 68.9613 95.3182Z",
    fill: "#B8D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M68.6275 95.3179H67.8594V171.997H68.6275V95.3179Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M59.4425 135.657L60.3048 138.235L62.1969 140.296L57.2178 141.506L58.6625 138.816L57.7262 136.519L59.4425 135.657Z",
    fill: "#B8D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M68.8187 93.6987L68.9109 96.4158L70.1374 98.9311L65.0203 98.6699L67.1713 96.5039L66.9281 94.035L68.8187 93.6987Z",
    fill: "#B8D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M59.7014 136.333C67.9227 133.185 71.362 122.192 67.3835 111.78C63.4049 101.368 53.515 95.4793 45.2937 98.6278C37.0724 101.776 33.633 112.769 37.6116 123.181C41.5901 133.593 51.4801 139.482 59.7014 136.333Z",
    fill: "#B8D3FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "uuid-b40723c2-846b-43d4-8d7a-d7be28bdc184-398",
    d: "M129.486 86.2465C132.077 87.0296 133.773 89.0025 133.275 90.6529C132.777 92.3034 130.274 93.0062 127.682 92.2226C126.643 91.9238 125.69 91.3801 124.903 90.637L113.969 87.1805L115.345 82.855L126.294 86.0271C127.361 85.844 128.455 85.9192 129.486 86.2465Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M110.489 57.8862L122.01 49.4277L121.626 65.5758L110.873 79.4169L122.394 84.0306L122.01 90.6182C122.01 90.6182 107.416 87.1064 105.112 86.722C102.808 86.3375 100.887 80.9548 100.887 80.9548L110.489 57.8862Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_14388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201.498,
    height: 200,
    fill: "white",
    transform: "translate(0.250977)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakePartComplete);
export default __webpack_public_path__ + "static/media/intake_part_complete.d192b52ac7dfc21f8fcb6a439a596368.svg";
export { ForwardRef as ReactComponent };